/**
 * Shared error-banner formatter.
 *
 * Each user-facing "Couldn't load this …" component appends the
 * server-minted (or client-minted) `exId` to the message so users
 * have a tag to quote in support requests — same tag that appears in
 * the server log line, the worker `console.error`, or the host
 * `console.error` depending on where the failure originated.
 *
 * See `docs/plans/error-correlation-ids.md` for the full design.
 */

/** Append `[EX:<id>]` to `msg` when an `exId` is present. */
export function formatError(msg: string, exId?: string): string {
  return exId ? `${msg} [EX:${exId}]` : msg;
}
